import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import { closeModalHookDef, fileType, fileUploadRequest, project, uploadedFile, uploadFileHookDef } from "./paperworkTypes";
import { store } from '../../redux/oldStore'
import { convertSingleImageToPdfAsFile } from "../../utils/PdfConverter";
import { toast } from "react-toastify";
import { set } from "lodash";


type FileUploadComponentProps = {
    fileTypes: fileType[];
    selectedFileTypeId: number;
    project: project;
    fileId: Number;
    closeModalHook: closeModalHookDef;
    fileUploadedHook: uploadFileHookDef;
}

enum fileUploadStatus {
    statusInitial = 0,
    statusSaving = 1,
    statusSuccess = 2,
    statusFailed = 3
}

type FileUploadComponentState = {
    showModal: boolean;
    uploadedFile?: userFileUpload;
    uploadError?: string;
    currentStatus: fileUploadStatus;
    selectedFileTypeId?: number;
}

type userFileUpload = {
    url: string;
    fileName: string;
}

const FileUploadComponent: FunctionComponent<FileUploadComponentProps> = (props:FileUploadComponentProps) => {

    const [status, setStatus] = useState<fileUploadStatus>(fileUploadStatus.statusInitial);
    const [selectedFileId, setSelectedFileId] = useState<number>(props.selectedFileTypeId);
    const [uploadedFile, setUploadedFile] = useState<userFileUpload | undefined>(undefined);


    const reset = () => {
        setSelectedFileId(props.selectedFileTypeId);
        setStatus(fileUploadStatus.statusInitial);
    }

    const save = async (files: FileList) => {
        //upload data to the server
        setStatus(fileUploadStatus.statusSaving);

        const success = (data: uploadedFile) => {
            console.debug(data);
            setUploadedFile({
                url: data.url,
                fileName: data.fileName
            });
            setStatus(fileUploadStatus.statusSuccess);
            //emit file-uploaded,
            props.fileUploadedHook();
            //close the modal
            props.closeModalHook();
        }

        const fail = (response: any) => {
            console.error(response);
            setStatus(fileUploadStatus.statusFailed);
            toast.error(response?.Message  || "There was a problem while uploading your file.");
        }

        const fileMetaData: fileUploadRequest = {
            projectId: props.project.ProjectIntId,
            fileTypeId: selectedFileId
        }

        const filesArray = Object.values(files);
        const processedFilesArray: File[] = []
        for (let i = 0; i < filesArray.length; i++) {
            const file = filesArray[i];
            if (file.type !== "application/pdf") {
                try {
                    processedFilesArray.push(await convertSingleImageToPdfAsFile(file));
                } catch {
                    toast.error("We are unable to convert your image to a pdf.")
                }
            } else {
                processedFilesArray.push(file);
            }
        }
        try {
            const result = await store.server?.postApiWithServerResponse<uploadedFile>('../PaperworkReview/FileUpload', fileMetaData, processedFilesArray);
            if (result?.Value) {
                success(result?.Value);
            } else {
                fail(result)
            }

        } catch (error) {
            fail(error);
        }
    }

    const filesChange = (fileList: FileList | null) => {
        if (!fileList?.length) return;
        save(fileList);
    }

    return (
        <>
            <div className="form-horizontal">
                <div className="form-group">
                    <label className="col-sm-2 control-label">File Type</label>
                    <div className="col-sm-10">
                        <select
                            className="form-control"
                            defaultValue={selectedFileId}
                        >
                            {props.fileTypes.map((x,i) => {
                                return (
                                    <option
                                        key={x.id}
                                        value={x.id}
                                        onClick={() =>{
                                            setSelectedFileId(x.id);
                                        }}
                                    >
                                        {x.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className="head-room">
                    {/* UPLOAD */}
                    {(status === fileUploadStatus.statusInitial || status === fileUploadStatus.statusSaving) &&
                        <form encType="multipart/form-data" noValidate>
                            <div className="dropbox">
                                {status === fileUploadStatus.statusInitial &&
                                    <p className="dropbox-text">
                                        <input type="file" name="pdfs" onChange={(evt) => filesChange(evt.target.files)} accept=".pdf,.jpg,.jpeg,.png" className="input-file"></input>
                                        Drag your file here<br /> or click to browse
                                    </p>
                                }
                                {status === fileUploadStatus.statusSaving &&
                                    <p>
                                        Uploading file...
                                    </p>
                                }
                            </div>
                        </form>
                    }
                    <br />
                    {status === fileUploadStatus.statusSuccess &&
                        <div>
                            <h2>Uploaded Successfully</h2>
                            <p>
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                <a href="#" onClick={reset}>Upload Again</a>
                            </p>
                            <ul className="list-unstyled">
                                <img src={uploadedFile?.url || ""} alt={uploadedFile?.fileName}></img>
                            </ul>
                        </div>
                    }
                    {status === fileUploadStatus.statusFailed &&
                        <div>
                            <h2>Upload Failed</h2>
                            <p>
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                                <a href="#" onClick={reset}>Try Again</a>
                            </p>
                        </div>
                    }
                </div>
            </div>
        </>);
}

export default FileUploadComponent;